import { Trash2 } from "lucide-react";
import { LucideProps } from "lucide-react";

interface DeleteIconProps extends LucideProps {
  className?: string;
}

export default function DeleteIcon({ className = "", size = 24, ...props }: DeleteIconProps) {
  return <Trash2 className={className} size={size} {...props} />;
}
